<template>
  <a-locale-provider :locale="zhCN">
    <router-view></router-view>
  </a-locale-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',
  setup () {
    return {
      zhCN
    }
  }
}
</script>
<style>
:root{
  --van-grid-item-content-background-color:transparent;
  --van-grid-item-text-color: #000000;
}
</style>
